import { render, staticRenderFns } from "./SocialList.vue?vue&type=template&id=e33327e0&scoped=true&"
import script from "./SocialList.vue?vue&type=script&lang=js&"
export * from "./SocialList.vue?vue&type=script&lang=js&"
import style0 from "./SocialList.vue?vue&type=style&index=0&id=e33327e0&scoped=true&lang=css&"
import style1 from "./SocialList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33327e0",
  null
  
)

export default component.exports